"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useSendTypingIndicator;

var _WebChatReduxContext = require("./internal/WebChatReduxContext");

function useSendTypingIndicator() {
  return [(0, _WebChatReduxContext.useSelector)(function (_ref) {
    var sendTypingIndicator = _ref.sendTypingIndicator;
    return sendTypingIndicator;
  })];
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1c2VTZW5kVHlwaW5nSW5kaWNhdG9yIiwidXNlU2VsZWN0b3IiLCJzZW5kVHlwaW5nSW5kaWNhdG9yIl0sInNvdXJjZVJvb3QiOiJjb21wb25lbnQ6Ly8vIiwic291cmNlcyI6WyIuLi8uLi9zcmMvaG9va3MvdXNlU2VuZFR5cGluZ0luZGljYXRvci50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyB1c2VTZWxlY3RvciB9IGZyb20gJy4vaW50ZXJuYWwvV2ViQ2hhdFJlZHV4Q29udGV4dCc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHVzZVNlbmRUeXBpbmdJbmRpY2F0b3IoKTogW2Jvb2xlYW5dIHtcbiAgcmV0dXJuIFt1c2VTZWxlY3RvcigoeyBzZW5kVHlwaW5nSW5kaWNhdG9yIH0pID0+IHNlbmRUeXBpbmdJbmRpY2F0b3IpXTtcbn1cbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOztBQUVlLFNBQVNBLHNCQUFULEdBQTZDO0VBQzFELE9BQU8sQ0FBQyxJQUFBQyxnQ0FBQSxFQUFZO0lBQUEsSUFBR0MsbUJBQUgsUUFBR0EsbUJBQUg7SUFBQSxPQUE2QkEsbUJBQTdCO0VBQUEsQ0FBWixDQUFELENBQVA7QUFDRCJ9